/**
 * Properties attached to every Phoenix Customer Account analytics event
 * so Mixpanel / Segment / CIO can be filtered apart from legacy Lyka apps.
 */
export const PHOENIX_EVENT_CONTEXT = {
  is_phoenix: true,
  app_surface: 'customer_account',
  brand: 'lyka',
} as const

export type PhoenixEventContext = typeof PHOENIX_EVENT_CONTEXT

export const withPhoenixEventContext = (
  properties?: Record<string, unknown> | null,
): Record<string, unknown> => ({
  ...PHOENIX_EVENT_CONTEXT,
  ...properties,
})
